<div class="edit-product-modal-container" *ngIf="operativeZone">
  <div class="edit-product-modal-title">
    {{"pool_parameters.EDIT_CONFIGURATION.0" | translate}} {{operativeZone.description}}

  </div>

  <div class="edit-product-modal-description">
    {{"pool_parameters.EDIT_CONFIGURATION.1" | translate}}

  </div>

  <div class="edit-product-modal-content">
    <form class="input-container" [formGroup]="OperativeZoneForm">

      <div class="input-group-container">
        <label>
          {{"pool_parameters.EDIT_CONFIGURATION.2" | translate}}

        </label>
        <div class="input-div">
          <input type="number" formControlName="timeLimit" />
        </div>
      </div>

    </form>
  </div>

  <div class="edit-product-modal-footer">
    <div class="button-white button-padding-10" (click)="closeModal()">{{'pool_parameters.EDIT_PRODUCT.6' | translate}}
    </div>
    <div class="button-green button-padding-10" (click)="saveParameters()"
      [ngClass]="{'button-opacity' : !isFormModified || OperativeZoneForm.invalid || SaveLoading }">
      {{'pool_parameters.EDIT_PRODUCT.7' | translate}}</div>

    <img class="loading-spinner" *ngIf="SaveLoading" src="../../../../../assets/loading-spinner.gif" alt="">
  </div>

</div>
